module.exports = "/_next/static/images/logo-offline-only-4642f50529aa7774617cb21c8079b6e5.png";